let chartArrayBuilder = (function () {

    const t = {};

    t.buildGraph = function (statistic, legends,legendType, interval, chartType, fromTime) {

        let allLabels = labelsBuilder.getIntervalDataLabelArrays(fromTime, interval);

        let statisticGraphSet = t.getStatisticSubsetByLegends(statistic, legends, legendType);
        let filledStatistic = t.fillStatistic(statisticGraphSet, legends, allLabels);

        allLabels = labelsBuilder.getReadableIntervalLabelArrays(fromTime, interval);

        let dataSets = [];
        let dataSetCount = 0;

        for (let key in legends) {

            let setData = this.prepareDataSetArray(filledStatistic, key);
            let legend = legends[key];

            let setOptions = chartProperties.getBasicSetOptions(dataSetCount);

            setOptions.label = legend;
            let set = this.buildDataSet(setData, setOptions);
            dataSets.push(set);

            dataSetCount++;
        }

        let Graph = {
            labels: allLabels,
            datasets: dataSets,
        };

        Graph.datasets[0].hidden = false;

        return Graph;
    };

    t.buildLabelsArray = function (statisticData) {
        let labels = [];

        for (var i = 0, keys = Object.keys(statisticData); i < keys.length; i++) {
            labels.push(statisticData[LABEL_TYPE]);
        }

    };

    t.prepareDataSetArray = function (statisticData, type) {
        return statisticData.map(function (entry) {
            return entry[type];
        });
    };

    t.buildDataSet = function (dataSet, options = {}) {
        return Object.assign({}, {
            data: dataSet,
        }, options);
    };

    t.fillStatistic = function (statistic, legends, allLabels) {

        let fields = Object.keys(legends);
        let emptyStatObject = createEmptyStatisticEntry(fields);

        let labelsWithData = this.prepareDataSetArray(statistic, X_AXIS_VAR);
        let paddedStatistic = [];


        Object.values(allLabels).forEach(value => {

            if (labelsWithData.indexOf(value) >= 0) {
                let statEntry = statistic.filter(obj => {
                    return obj[X_AXIS_VAR] === value;
                });

                if (statEntry.length > 0) {
                    paddedStatistic.push(statEntry.pop());
                } else {
                    let emptyObj = Object.assign({}, emptyStatObject);
                    emptyObj[X_AXIS_VAR] = value;
                    paddedStatistic.push(emptyObj);
                }

            } else {
                let emptyObj = Object.assign({}, emptyStatObject);
                emptyObj[X_AXIS_VAR] = value;
                paddedStatistic.push(emptyObj);
            }
        });

        return paddedStatistic;

    };

    /**
     * Filter statistic based on which legends is currently chosen
     *
     * @param fullStatisticSet
     * @param legends
     * @param legendType
     * @returns {Array}
     */
    t.getStatisticSubsetByLegends = function (fullStatisticSet, legends, legendType) {

        let statisticOutput = [];
        let fieldToOutput = Object.keys(legends);

        Object.values(fullStatisticSet).forEach(function (statPoint) {
            let statisticEntry = {};
            Object.keys(statPoint).forEach(function (statLegend) {

                if (fieldToOutput.indexOf(statLegend) > -1) {

                    if(legendType === 'timer'){

                        let minutes = Math.floor(statPoint[statLegend] / 60);
                        let seconds = statPoint[statLegend] % 60;
                        let decimal = minutes + (seconds / 60);

                        statisticEntry[statLegend] = decimal;
                    }else{
                        statisticEntry[statLegend] = statPoint[statLegend];
                    }
                }
            });

            statisticEntry[X_AXIS_VAR] = statPoint[X_AXIS_VAR];
            statisticOutput.push(statisticEntry);

        });
        return statisticOutput;
    };

    function createEmptyStatisticEntry(fields) {
        let newObject = {};

        Object.values(fields).forEach(value => {
            newObject[value] = 0;
        });

        return newObject;
    };

    function legendHandler(e, legendItem) {
        if (this.chart.legend.legendItems !== undefined) {
            Object.keys(this.chart.legend.legendItems).forEach(key => {
                let meta = this.chart.getDatasetMeta(key);
                meta.hidden = true;

                if (legendItem.datasetIndex === parseInt(key)) {
                    let meta = this.chart.getDatasetMeta(key);
                    meta.hidden = false;
                }
            });
        }
        this.chart.update();
    }

    return t;

})();
